//=include _jquery.flipster.min.js

$(document).ready(function() {
	if ($('#carrousel_ambassadeurs li').length > 1) {
		$('#carrousel_ambassadeurs').flipster({
			itemContainer: 'ul',
			itemSelector: 'li',
			start: 0,
			fadeIn: 400,
			loop: true,
			autoplay: false,
			pauseOnHover: true,
			style: 'flat',
			spacing: -0.3,
			click: true,
			keyboard: true,
			scrollwheel: false,
			touch: true,
			nav: false,
			buttons: true,
			buttonPrev: 'Previous',
			buttonNext: 'Next',
			onItemSwitch: false
		});
	}
});
